import { TemplateResult } from 'lit';

export interface MegaMenuSection {
  label: string;
  icon: string;
  items: MegaMenuItem[];
}

export interface MegaMenuItem {
  label: string;
  event: string;
  action?: Function;
  disabledMessage?: string;
  disabled?: boolean;
  isQuickAction?: boolean;
  icon?: string;
  id?: string;
}

// key-value pairs needed for providing the icons for this component
// key is a custom icon name (used in MegaMenuSection.icon)
// value is a TemplateResult which should only contain the svg code for that icon
//  make sure to include slot="custom-svg" in the <svg> tag, for gz-icon to be able to render the custom icon
export interface MegaMenuIconMap {
  [icon: string]: TemplateResult;
}

export enum MegaMenuEvents {
  ITEM_CLICKED = 'mega-menu-item-clicked',
  COMPUTE_MEGA_MENU_SECTIONS = 'compute-mega-menu-sections',
}
